import { request } from "../network/request";
const db = "dn0";
//查询IT服务周报配置信息
export function getItWeeklyList(params) {
  return request({
    url: "pmp/xmzb/selectItWeeklConfig",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}
/**
 *
 * @param {*} type 说明：类型1 总部-分公司 2分公司-总部
 * @param {*} range 说明：数据范围 1-角色数据权限 0-全部
 * @returns
 */
export function getBmxxList(type, range) {
  return request({
    url: "system/getBmxxList",
    method: "get",
    params: {
      db,
      type,
      range,
    },
  });
}
/**
 *
 * @param {*} xmlx 项目类型，多个,隔开，如DS,SW,SD,TS ;0-全部
 * @param {*} range 数据范围 1-角色数据权限 0-全部
 * @param {*} xmzt 项目状态，多个,隔开，如1,3  ;0-全部
 * @param {*} bmbh 部门编号
 * @param {*} xmjd 项目阶段
 * @returns
 */
export function getXmxxList(xmlx, range, xmzt, bmbh, xmjd) {
  return request({
    url: "system/getXmxxList",
    method: "get",
    params: {
      db,
      xmlx,
      range,
      xmzt,
      bmbh,
      xmjd,
    },
  });
}


export function getXmxxList2(xmlx, range, xmzt, bmbh, xmjd) {
  return request({
    url: "system/getXmxxList2",
    method: "get",
    params: {
      db,
      xmlx,
      range,
      xmzt,
      bmbh,
      xmjd,
    },
  });
}

export function getXmxxList3(xmlx, range, xmzt, bmbh, xmjd) {
  return request({
    url: "system/getXmxxList3",
    method: "get",
    params: {
      db,
      xmlx,
      range,
      xmzt,
      bmbh,
      xmjd,
    },
  });
}
/**
 *
 * @param {*} params
 * id integer 编号 如果传值，表示编辑
 * xmbh 项目编号
 * cksjl 存款数据量（条） 大于0 的正数
 * dksjl 贷款数据量（条） 大于0 的正数
 * lzqkbf 两周全库备份 1-是 0-否 默认是
 * mzgjbbf  每周关键表备份 1-是 0-否 默认是
 * bz 备注
 * @returns
 */
export function saveItWeeklConfig(params) {
  return request({
    url: "pmp/xmzb/saveItWeeklConfig",
    method: "post",
    data: {
      db,
      ...params,
    },
  });
}
